import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/location_new/uk-mobile/apps_developed_uk.webp";
import { StaticImage } from "gatsby-plugin-image";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Mobileappukcta({ handleShow }) {
  return (
    <section
      className="mobile_app_ukcta business_growth_uk p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={6}
            xxl={6}
            className="offset-lg-4 offset-md-1 offset-xl-6"
          >
            <h2>
              We've Delivered <span>200+ Mobile App Solutions</span> Across
              Multiple Industries!
            </h2>
            <p>
              Partner up with TekRevol to upscale your business prospect with a
              purpose-built app solution.
            </p>
            <div className="app_growth_main">
              <div className="app_growth_item">
                <div className="app_all">
                  <div className="app_growth_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/get_phone_icon.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={57}
                      height={57}
                    />
                  </div>
                  <div className="app_growth_num">
                    <Link to="tel:+441223926620">+441-223-926620</Link>
                  </div>
                </div>
              </div>
              <div className="app_growth_item">
                <h5>OR</h5>
              </div>
              <div className="app_growth_item">
                <button
                  style={{ background: "#F47a14", color: "#fff" }}
                  onClick={handleShow}
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Talk Our App Development Team
                </button>
              </div>
            </div>
            {/* <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Free Consultation Today
            </Link> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Mobileappukcta;
